export default {
  'applicant_info': '/applicant-info',
  'applicant_info_major_subject': '/preferred-subjects',
  'applicant_info_second_subjects': '/preferred-subjects-other',
  'welcome_page': '/welcome',
  'language_test': '/language-test',
  'language_test_failed': '/language-test/failed',
  'math_test': '/math-test',
  'math_test_start': '/math-test-start',
  'finance_text_test': '/finance-test',
  'finance_text_test_start': '/finance-test-start',
  // 'finance_test': '/finance-test',
  // 'finance_test_start': '/finance-test-start',
  'phone_verification': '/phone-verification',
  'tutorial': '/tutorial-start',
  'tutorial_started': '/tutorial',
  'academic_test': '/academic-test',
  'essay_1': '/tasks',
  'essay_1_success': '/perfect_essay',
  'essay_2': '/tasks',
  'essay_3': '/tasks',
  'essay_4': '/tasks',
  'essay_5': '/tasks',
  'phone_verification_2': '/phone-verification-2',
  'await_result': '/result',
  'hired': '/congratulations',
  'declined': '/sorry',

  'essay_1_success_v0': '/task-completed',
  'essay_2_success_v0': '/task-completed',
};



// WEBPACK FOOTER //
// ./src/constants/stages.js